









































































import {Component, Vue} from "vue-property-decorator";
import {
  PullRefresh,
  Swipe,
  SwipeItem,
  Icon,
  Empty,
  List,
  Loading, Toast
} from "vant";
import FundsRecordItem from "@/components/FundsRecordItem.vue";
import {jumpLink,webViewRightButton} from "@/utils/hybirdMethods";
import {getBrowser} from "@/utils/browser";


import Clipboard from "clipboard";

import amountDisplay from '@/mixins/amountDisplay'

@Component({
  components: {
    [PullRefresh.name]: PullRefresh,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Icon.name]: Icon,
    [FundsRecordItem.name]: FundsRecordItem,
    [Empty.name]: Empty,
    [List.name]: List,
    [Loading.name]: Loading
  },
  mixins: [
    amountDisplay
  ]
})
export default class Index extends Vue {
  accountData: any = null;
  hasBindBankCard: any = null;
  fundsRecordList: any = null;
  isFinishRe1 = false;
  accountRequestFail = false;
  isFinishRe3 = false;
  recordRequestFail = false;
  // myLoading: any = null;
  loadText: any = "";
  IMG_NET_ERR = (this as any).IMG_NET_ERR;
  account_no: String = ''

  accountInfoList:any = null
  imgArrayObj:any = null
  withdrawInUrl:any = '/static/images/funds_in.png'
  withdrawOutUrl:any = '/static/images/funds_out.png'
  accountDetailUrl:any = '/static/images/funds_capital.png'
  exchangeUrl:any = '/static/images/funds_swap.png'
  fundsTransferUrl:any = '/static/images/funds_transfer.png'

  loading = false;
  finished = false;
  currPage = 1;
  pageSize = 10;
  isApp = getBrowser().isApp;
  exchange = 0;
  isLoading:any = false;

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  created() {
    this.loadText = this.$t("public.contentText[4]") || "";
    this.init();
	webViewRightButton({"url":{"type":1,"url":"/funds-management-pre"},"isDisplay":"false","title":""})


  }

  init() {
	this.getAccountList();
  }
  onRefresh(){
	this.getAccountList();
  }

  getAccountList(){
	  (this as any).isLoading = true;
	  (this as any).$apis.getAccountLists().then(res =>{
		 this.isLoading = false
		 this.accountInfoList = res.accountInfo
		 this.imgArrayObj = res.accountAuth
	  })
  }

  /**
   * 点击复制账号
   * */
  onCopy () {
    const clipboard = new Clipboard('.account_no')
    clipboard.on('success', e => {
      Toast.success(this.$t('funds.copy'))
      // 释放内存
      clipboard.destroy()
    })
    clipboard.on('error', e => {
      // 不支持复制
      Toast.fail(this.$t('funds.copyFail'))
      // 释放内存
      clipboard.destroy()
    })
  }

  /**
   * 返回是否绑定银行卡
   */
  get isBindBankCard() {
    if (this.hasBindBankCard === null) {
      return "";
    } else {
      return this.hasBindBankCard
          ? this.$t("funds.jsText[0]")
          : this.$t("funds.jsText[1]");
    }
  }
  /**
   * 格式化账户信息-可转出金额(合计)
   * @param item {Object} 账户信息
   * @param index {Number} 序列号
   */
  amountText(item) {
	return (item && Number(item).toFixed(2)) || "--"
  }

  /**
   * 格式化账户信息-账户(总)金额
   * @param item {Object} 账户信息
   */
  balanceText(item) {
	return (item && Number(item).toFixed(2)) || "--"
  }

  /**
   * 格式化账户信息-币种
   * @param item {Object} 账户信息
   */
  currencyText(item) {
    switch (item) {
      case "USD":
        return this.$t("funds.currencyText[0]");
      case "HKD":
        return this.$t("funds.currencyText[1]");
      case "CNH":
        return this.$t("funds.currencyText[2]");
      default:
        return "";
    }
  }

  /**
   * 跳转银行卡列表页
   */
  jumpToBankCardList() {
    this.$router.push({name: "bank-card-list"});
  }

  /**
   * 跳转到资金币种详情
   * @param e
   * @param item {Object} item数据
   */
  jumpToFundsDetails(e,item) {
	e.stopPropagation()
    const routeParams: any = {
      name: "funds-details"
    };
    routeParams.query = {
      account_type: item.account_type,
      account_no: item.account_no
    };
    this.$router.push(routeParams);
  }

  handCardClick(e,item){
	e.stopPropagation()
	this.$router.push({
		path:'/funds-management',
		query:{
		  account:item.account_no,
		  account_type: item.account_type
		}
	})
  }

  /**
   * 跳转到 资金转入/转出/划转
   * @param item {Object} item数据
   * @param accountItem {Object} 账户数据
   * type: 1: A账户 2：B账户
   */
  jumpToFundsTransfer(e,item, accountItem) {
	e.stopPropagation()
    switch (item) {
      case this.$t("funds.btnText[0]"):
        this.$router.push({
          name: "transfer-into-index",
          // query: {type: accountItem.account_type}
          query: {account_type: accountItem.account_type, account_no: accountItem.account_no || accountItem.login_id}
        });
        break;
      case this.$t("funds.btnText[1]"):
        this.$router.push(
            `/withdraw?account_type=${
                accountItem.account_type
            }&account_no=${accountItem.account_no || accountItem.login_id || ""}`
        );
        break;
      case this.$t("funds.btnText[2]"):
        if (this.isApp) {
          jumpLink({
            url: 'exchange',
            futures_login_id: accountItem.account_no,
            x_channel_id: accountItem.account_type
          });
        }
        // this.$router.push(
        //   `/withdraw?type=${
        //     accountItem.type
        //   }&account_no=${accountItem.account_no || accountItem.login_id}`
        // );
        break;
      case this.$t("funds.btnText[3]"):
        // this.$router.push(
        //   `/transfer?type=${
        //     accountItem.type
        //   }&account_no=${accountItem.account_no || accountItem.login_id}`
        // );
        (this as any).jumpToFundsDetails(accountItem);
        break;
	  case this.$t("transfer.nav_title"):
	    this.$router.push(
	      `/transfer?account_type=${
	        accountItem.account_type
	      }&account_no=${accountItem.account_no}`
	    );
	    break;
      default:
        return;
    }
  }


  jumpToAppPage() {
    if (this.isApp) {
      jumpLink("capital_flow");
    }
  }

  beforeDestroy() {
    // this.myLoading.clear();
  }

  // @Watch("isFinishedRequest")
  // watchIsFinishedRequest(val) {
  //   val && this.myLoading.clear();
  // }
}
